import { Dispatch } from 'redux';
import { typedAction } from 'store/modules/base';
import { GETLiquidacoes, LiquidacaoComprovanteDTO, POSTComprovante } from 'requests/liquidacoes';
import { IPaginatedData } from 'common/genericTypes';
import { LiquidacaoData } from 'pages/liquidacoes';

export interface LiquidacoesApiState {
  postComprovante(dispatch: Dispatch, liquidacao: LiquidacaoComprovanteDTO, stackRequest?: boolean): Promise<string>;
  getLiquidacoes(dispatch: Dispatch, query: string, stackRequest?: boolean): Promise<IPaginatedData<LiquidacaoData>>;
}

const liquidacoesApiInitialState: LiquidacoesApiState = {
  postComprovante: POSTComprovante,
  getLiquidacoes: GETLiquidacoes,
};

enum LiquidacoesApiActionType {
  Update = 'liquidacoesApi/UPDATE',
  Reset = 'liquidacoesApi/RESET',
}

export const updateLiquidacoesApi = (state: LiquidacoesApiState) => {
  return typedAction(LiquidacoesApiActionType.Update, state);
};

export const resetLiquidacoesApi = () => {
  return typedAction(LiquidacoesApiActionType.Reset);
};

type LiquidacoesApiAction = ReturnType<typeof updateLiquidacoesApi | typeof resetLiquidacoesApi>;

export function liquidacoesApiReducer(
  state: LiquidacoesApiState = liquidacoesApiInitialState,
  action: LiquidacoesApiAction
): LiquidacoesApiState {
  switch (action.type) {
    case LiquidacoesApiActionType.Update:
      return { ...action.payload };
    case LiquidacoesApiActionType.Reset:
      return { ...liquidacoesApiInitialState };
    default:
      return state;
  }
}
